import Xhr from '../../core/xhr'

export default {
  namespaced: true,
  state: {
    loading: false,
    advancedform: new Xhr({
      user: null,
      course: null,
      seminar: null,
      education: null,
      experience: null,
      declaration: null,
      passport: null,
      letter: null,
      photo: null,
      documents: []
    }),
    countries: [],
    seminare: []
  },
  mutations: {
    user (state, user) {
      state.advancedform.user = user
    },
    education (state, education) {
      state.advancedform.education = education
    },
    experience (state, experience) {
      state.advancedform.experience = experience
    },
    course (state, course) {
      state.advancedform.course = course
    },
    loading (state, loading) {
      state.loading = loading
    },
    countries (state, countries) {
      state.countries = countries
    },
    seminare (state, seminare) {
      state.seminare = seminare
    },
    seminar (state, seminar) {
      state.advancedform.seminar = seminar
    },
    updateForm (state, [field, data]) {
      state.advancedform[field] = data
    }
  },
  actions: {
    updateUser ({ commit }, { user }) {
      commit('user', user)
    },
    updateEducation ({ commit }, { education }) {
      commit('education', education)
    },
    updateExperience ({ commit }, { experience }) {
      commit('experience', experience)
    },
    updateCourse ({ commit }, { course }) {
      commit('course', course)
    },
    updateSeminar ({ commit }, seminar) {
      commit('seminar', seminar || null)
    },
    updateForm ({ commit }, [field, data]) {
      commit('updateForm', [field, data])
    },
    async fetchData ({ commit, rootState }) {
      try {
        var { countries, seminare } = await new Xhr().get(`${rootState.url}/advanced-form/data`)
        commit('countries', countries)
        commit('seminare', seminare)
      } catch (error) {
        console.log(error)
      }
      return { countries, seminare } || { success: false }
    },
    async sendForm ({ commit, state, rootState }) {
      commit('loading', true)
      try {
        var response = await state.advancedform.post(`${rootState.url}/advanced-form/store`, {
          headers: { 'content-type': 'multipart/form-data' }
        })
      } catch (error) {
        console.log(error)
      }
      commit('loading', false)
      return response || { success: false }
    }
  }
  // getters: {
  //     showAdditionalFields: state => state.advancedform.options.package === "0"
  // }
}
